import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';

import '../icon/element.js';

/**
 * Component with main content and left and right slots for additional content;
 * Example of List header
 *
 * @prop icon - placeholder icon (optional)
 * @prop name - title of the post
 * @prop desc - description (optional)
 * @prop href - link to the post
 *
 * @slot left - For additional content on the left
 * @slot right - For additional content on the right
 *
 */
export default class ListHeader extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    icon: { type: String },
    name: { type: String },
    href: { type: String },
    desc: { type: String },
  };

  renderIcon() {
    return html` <ef-icon name="${this.icon}"></ef-icon> `;
  }

  renderSpan() {
    return html` <span>${this.name}</span> `;
  }

  renderLink() {
    return html` <a href="${this.href}">${this.name}</a> `;
  }

  renderDesc() {
    return html` <div class="list-header-info">${this.desc}</div> `;
  }

  render() {
    return html`
      <slot name="left"> ${this.icon && this.renderIcon()} </slot>

      <div class="list-header-content">
        <h2 class="list-header-title">
          ${this.href ? this.renderLink() : this.renderSpan()}
        </h2>
        ${this.desc && this.renderDesc()}
      </div>

      <slot name="right"></slot>
    `;
  }
}

customElements.get('ef-list-header') ||
  customElements.define('ef-list-header', ListHeader);
